import React, { useState, useEffect } from 'react';

export default function Topbar({ onActivity, onAddTask, onSignOut, syncLabel, syncState }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  const dotColor = syncState === 'live' ? '#10B981' : syncState === 'error' ? '#EF4444' : '#94A3B8';

  return (
    <header style={{ ...styles.topbar, padding: isMobile ? '12px 16px' : '18px 32px' }}>
      <div style={styles.brand}>
        <div style={styles.logo}>
          <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
            <path d="M12 2 L19 8 V15 C19 18.5 15.866 21 12 21 C8.134 21 5 18.5 5 15 V8 Z" fill="white" opacity=".95"/>
            <path d="M12 7 V15 M9 11 H15" stroke="#0A2540" strokeWidth="1.8" strokeLinecap="round"/>
          </svg>
        </div>
        {!isMobile && (
          <div>
            <div style={styles.brandName}>DialyGo · Execution OS</div>
            <div style={styles.brandSub}>INTERNAL · V0.2</div>
          </div>
        )}
        {isMobile && <div style={styles.brandName}>DialyGo</div>}
      </div>

      <div style={{ ...styles.right, gap: isMobile ? 6 : 10 }}>
        <button onClick={onAddTask} style={styles.addBtn}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" width="14" height="14">
            <path d="M12 5v14M5 12h14"/>
          </svg>
          {!isMobile && 'New task'}
        </button>

        <button onClick={onActivity} style={{ ...styles.ghostBtn, padding: isMobile ? '8px' : '8px 12px' }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" width="16" height="16">
            <path d="M12 8v4l3 3"/><circle cx="12" cy="12" r="10"/>
          </svg>
          {!isMobile && 'Activity'}
        </button>

        <div style={{ ...styles.syncPill, padding: isMobile ? '5px 8px' : '5px 12px' }}>
          <span style={{ ...styles.syncDot, background: dotColor, animation: syncState==='live' ? 'pulse 2s infinite' : 'none' }} />
          {isMobile ? (
            <span style={styles.syncText}>{syncState === 'live' ? 'Live' : syncLabel}</span>
          ) : (
            <span style={styles.syncText}>{syncLabel}</span>
          )}
        </div>

        <button onClick={onSignOut} style={{ ...styles.signOutBtn, padding: isMobile ? '6px 8px' : '6px 10px' }}
          onMouseEnter={e => { e.currentTarget.style.background='#FEE2E2'; e.currentTarget.style.color='#991B1B'; }}
          onMouseLeave={e => { e.currentTarget.style.background='transparent'; e.currentTarget.style.color='#3D5878'; }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" width="15" height="15">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          {!isMobile && 'Sign out'}
        </button>
      </div>
    </header>
  );
}

const styles = {
  topbar: {
    display:'flex', alignItems:'center', justifyContent:'space-between',
    background:'rgba(255,255,255,.9)',
    backdropFilter:'blur(14px)',
    WebkitBackdropFilter:'blur(14px)',
    borderBottom:'1px solid #E4ECF4',
    position:'sticky', top:0, zIndex:50,
  },
  brand: { display:'flex', alignItems:'center', gap:10 },
  logo: {
    width:36, height:36, borderRadius:10, flexShrink:0,
    background:'linear-gradient(135deg,#0A2540 0%,#1E4060 100%)',
    display:'grid', placeItems:'center',
    boxShadow:'0 4px 12px rgba(10,37,64,.18)',
  },
  brandName: { fontWeight:600, fontSize:15, letterSpacing:'-0.01em' },
  brandSub: { fontSize:11, color:'#7A8BA3', fontFamily:"'JetBrains Mono',monospace", textTransform:'uppercase', letterSpacing:'0.08em', marginTop:2 },
  right: { display:'flex', alignItems:'center' },
  addBtn: {
    display:'inline-flex', alignItems:'center', gap:6, padding:'8px 14px',
    borderRadius:8, fontSize:13, fontWeight:500, cursor:'pointer', border:'none',
    background:'#0A2540', color:'white', transition:'all .15s ease',
  },
  ghostBtn: {
    display:'inline-flex', alignItems:'center', gap:6,
    borderRadius:8, fontSize:13, color:'#3D5878', background:'none', border:'none', cursor:'pointer',
  },
  syncPill: { display:'flex', alignItems:'center', gap:5, borderRadius:99, fontSize:11, background:'#F1F5F9', border:'1px solid #E4ECF4', color:'#3D5878', fontFamily:"'JetBrains Mono',monospace", whiteSpace:'nowrap' },
  syncDot: { width:6, height:6, borderRadius:'50%', display:'inline-block', flexShrink:0 },
  syncText: {},
  signOutBtn: {
    display:'inline-flex', alignItems:'center', gap:5,
    borderRadius:8, fontSize:12,
    color:'#3D5878', border:'none', cursor:'pointer', transition:'all .15s ease',
  },
};
